import { render, staticRenderFns } from "./rf_layout.vue?vue&type=template&id=9b1edb82&scoped=true&"
import script from "./rf_layout.vue?vue&type=script&lang=js&"
export * from "./rf_layout.vue?vue&type=script&lang=js&"
import style0 from "./rf_layout.vue?vue&type=style&index=0&id=9b1edb82&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b1edb82",
  null
  
)

export default component.exports